import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { ContactPageFragment } from '../../features/page'
import type { Props } from '../../features/page/components/page'

export const mount: MountWithRootOptions<Props> = async (rootElement, renderProps, rootOptions) => {
  return clientMount(<ContactPageFragment {...renderProps} />, rootElement, rootOptions)
}
